import React from "react";
import ProgImgSlider from "./ProgImgSlider";
import ProgDATA from "./ProgDATA";

const ProgramHero = ({ program, images }) => {
  return (
    <div
      className="d-flex gap20 bg-white radius5 px-20 py-20 mt-10"
      id="progHero"
    >
      <ProgImgSlider lotsImages={images} />
      <ProgDATA programme={program} />
    </div>
  );
};

export default ProgramHero;
